module.exports = __webpack_public_path__ + "static/media/Guru Bumi(1).4a781556.png";